document.addEventListener('DOMContentLoaded', function() {
  var mainSwiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    zoom: {
      maxRatio: 2,
      minRatio: 1,
    },
    loop: true,
    fade:true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });

  document.querySelectorAll('.slider_thumbs_div').forEach((thumb)=>{
    thumb.addEventListener('click',(event)=>{
      document.querySelector('.slider_thumbs_div.active').classList.remove('active');
      thumb.classList.add('active');
      const thumbIndex = parseInt(thumb.dataset.thumb);
      document.querySelectorAll('.swiper-pagination-bullet').forEach((bullet)=>{
       let attribute =  bullet.getAttribute('aria-label');
        const splitArray = attribute.split(/\bslide\s+/);
        const numberAfterString = splitArray[1];
        if(numberAfterString == thumbIndex) bullet.click();
      })
    })
    
    
  })
});